import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Box from '@mui/material/Box';

import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import CancelIcon from '@mui/icons-material/Cancel';
import Tooltip from '@mui/material/Tooltip';

import { getAPI, postAPI } from '../util/APIUtils';

import { downloadData, uploadData } from 'aws-amplify/storage';
import { UploadFile } from '../states/viewerState';

const NestedListItem = (props) => (
  <ListItem sx={{
    paddingLeft: 2 * props.level,
    backgroundColor: (theme) => theme.palette.grey[100],
  }}>{props.children}</ListItem>
);

type Props = {
  openDialogRequest: OpenDialogRequest,
  open: boolean;
  idid: string;
  handleClose: () => void;
  completeUploadFileDialog: (nodeId: string, uploadFile: UploadFile[]) => void;
};

export type OpenDialogRequest = {
  actId: string;
  nodeId: string;
  uploadFile: UploadFile[],
};

type Alias = {
  type: 'RevisionAct' | 'ContrastTable' | 'Etc1' | 'Etc2' | 'Etc3',
  text: string,
}

export const UploadFileDialog: React.FC<Props> = (props) => {

  const [newUploadFile, setNewUploadFile] = React.useState<UploadFile[]>([]);
  const [newAlias, setNewAlias] = React.useState<Alias[]>([]);

  const handleSetFile = (nodeId: string, type: "RevisionAct" | "ContrastTable" | "Etc1" | "Etc2" | "Etc3", file) => {
    const newArray = newUploadFile.slice();
    const obj = newArray.find(f => type === f.type);
    if (obj) {
      newArray.splice(newArray.indexOf(obj), 1);
    }
    // ファイル名に日本語が含まれるとうまくいかないため、仮の名前に置き換える
    const newName = '' + new Date().getTime() + '_' + nodeId + '.' + file.name.split('.').pop();
    newArray.push({ type: type, alias: '', fileName: newName, fileObj: file });
    setNewUploadFile(newArray);
  };

  const handleRemoveFile = (nodeId: string, type: string) => {
    const newArray = newUploadFile.slice();
    const obj = newArray.find(f => type === f.type);
    if (obj) {
      newArray.splice(newArray.indexOf(obj), 1);
      setNewUploadFile(newArray);
    }
  };
  const selectedFile = (nodeId, type) => (e) => {
    if (!e.target.files[0]) return;
    // ファイル形式チェック（doc・docx・rtf・xls・xlsx・pdf・jpg・jpeg・png・gif・csv・jtd・zip）
    const exts = ['doc', 'docx', 'rtf', 'xls', 'xlsx', 'pdf', 'jpg', 'jpeg', 'png', 'gif', 'csv', 'jtd', 'zip'];
    const ext = e.target.files[0].name.split('.').pop().toLowerCase();
    if (exts.indexOf(ext) === -1) {
      // タイプエラー
      setSubDialog2(true);
      e.target.value = '';
      return;
    }
    // ファイルサイズチェック（5MB：5,242,880）
    if (e.target.files[0].size >= 1024 * 1024 * 5) {
      setSubDialog4(true);
      e.target.value = '';
      return;
    }
    handleSetFile(nodeId, type, e.target.files[0]);
  };

  const handleComplete = async () => {
    const newArray = newUploadFile.slice();
    // エイリアス設定
    for (let f of newAlias) {
      const aa = newArray.find(g => g.type === f.type);
      if (aa) {
        aa.alias = f.text;
      } else {
        newArray.push({
          alias: f.text,
          type: f.type,
          fileName: '',
        })
      }
    }
    //  ファイルをS3へアップロード
    for (let f of newArray) {
      if (f.fileObj) {
        // ファイルだけ更新する場合は、元のエイリアス名を取得
        if (!f.alias) {
          const uf = getFile(f.type);
          f.alias = uf ? uf.alias : "";
        }
        // await Storage.put(f.fileName, f.fileObj, {
        //   level: 'private',
        //   contentType: 'text/plain'
        // });
        if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
          const apiurl = `/tempfile`;
          const options = {
            path: `private/${props.idid}/${f.fileName}`,
            contenttype: f.fileObj.type,
          };
          const json = await postAPI(apiurl, options);
          const realuploadurl = (process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT && process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT) ? json.uploadUrl.replace(process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT, process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT) : json.uploadUrl;

          const uploadResponse = await fetch(realuploadurl, {
            method: 'PUT',
            body: f.fileObj,
            headers: {
              'Content-Type': f.fileObj.type,
            },
          });

          if (!uploadResponse.ok) {
            console.error('アップロード失敗', uploadResponse.status, uploadResponse.statusText);
          }

        } else {
          await uploadData({
            path: `private/${props.idid}/${f.fileName}`,
            data: f.fileObj,
          });
        }
      }
    }
    // ここか全編集開始時（？）にファイルリストStateをクリアしないと残り続ける
    setNewUploadFile([]);
    setNewAlias([]);
    // action呼び出し
    props.completeUploadFileDialog(props.openDialogRequest.nodeId, newArray);
  };

  const handleClose = async () => {
    setNewUploadFile([]);
    setNewAlias([]);
    props.handleClose();
  };

  const handleAliasTxt = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    const newTxt = value.replace(/[\s]/g, '');
    const labels = (event.target as HTMLInputElement).labels!;
    const type =
      labels[0].innerText === '改正文' ? 'RevisionAct' :
        labels[0].innerText === '新旧対照表' ? 'ContrastTable' :
          labels[0].innerText === 'その他1の任意表示文字列' ? 'Etc1' :
            labels[0].innerText === 'その他2の任意表示文字列' ? 'Etc2' : 'Etc3'

    const newArray = newAlias.slice();
    const obj = newArray.find(f => type === f.type);
    if (obj) {
      newArray.splice(newArray.indexOf(obj), 1);
    }
    newArray.push({ type: type, text: newTxt });
    setNewAlias(newArray);
  };

  // ダウンロード
  const downloadFile = async (actId: string, nodeId: string, fileName: string) => {
    if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
      downloadFormLGWAN(actId, nodeId, fileName);
    } else {
      downloadForm(actId, nodeId, fileName);
    }
  };

  const downloadFormLGWAN = async (actId: string, nodeId: string, fileName: string) => {
    const path = `${actId}/Uploaded/${nodeId}/${fileName}`;

    const apiurl = `/tempfile?path=private/${props.idid}/${path}`;
    const json = await getAPI(apiurl);
    const realdownloadurl = (process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT && process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT) ? json.downloadUrl.replace(process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT, process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT) : json.downloadUrl;

    const file = await fetch(realdownloadurl);
    const blob = await file.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', path);
    document.body.appendChild(link);
    link.click();
  };

  const downloadForm = async (actId: string, nodeId: string, fileName: string) => {
    const path = `${actId}/Uploaded/${nodeId}/${fileName}`;
    // const file = await Storage.get(path, { level: 'private' });
    const downloadTask = await downloadData({
      path: `private/${props.idid}/${path}`,
    });
    const { body } = await downloadTask.result;
    const blob = new Blob([await body.blob()]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    //const filename = path.split('/').pop();
    link.setAttribute('download', path);
    document.body.appendChild(link);
    link.click();
  };

  const handleDeleteUploadFile = (existUploadFile: UploadFile) => {
    const newArray = newUploadFile.slice();
    const obj = newArray.find(f => existUploadFile.type === f.type);
    if (obj) {
      obj.delete = true;
    } else {
      const newFile = JSON.parse(JSON.stringify(existUploadFile));
      newFile.delete = true;
      newArray.push(newFile);
    }
    setNewUploadFile(newArray);
  };

  const createUploadFileItem = (type: string, existUploadFile?: UploadFile) => {
    const label =
      type === 'RevisionAct' ? '改正文' :
        type === 'ContrastTable' ? '新旧対照表' :
          type === 'Etc1' ? 'その他1の任意表示文字列' :
            type === 'Etc2' ? 'その他2の任意表示文字列' : 'その他3の任意表示文字列'

    const newFile = newUploadFile.find(f => type === f.type);

    if (newFile && newFile.delete) {
      return (
        <>
          <span style={{ fontWeight: 'bold' }}>{label}</span>
          <br />
          <Typography variant="body1" component="span" color="secondary" sx={{ margin: (theme) => theme.spacing(2) }}>削除されます</Typography>
          <br />
        </>
      );
    }

    const newFileObj = newFile ? (
      <>
        <label style={{ 'margin': 10 }}>{newFile && newFile.fileObj.name}</label>
        <Button color="secondary" variant='outlined' component='span' onClick={() => handleRemoveFile(props.openDialogRequest.nodeId, type)}>Cancel</Button>
      </>
    ) : '';

    const aliasText = (() => {
      const obj = newAlias.find(f => type === f.type);
      if (obj) {
        return obj.text || '';
      } else {
        if (existUploadFile) {
          return existUploadFile.alias || '';
        }
      }
    })();

    const aliasTextField = () => {
      if (type === 'RevisionAct' || type === 'ContrastTable') {
        return (
          <>
            <br />
          </>
        );
      } else {
        return (
          <>
            <TextField
              id={props.openDialogRequest.nodeId + type}
              label={label}
              multiline
              value={aliasText}
              sx={{
                marginLeft: (theme) => theme.spacing(1),
                marginRight: (theme) => theme.spacing(1),
                width: '30%',
              }}
              onChange={handleAliasTxt}
              margin="normal"
              variant="outlined"
            />
            <br />
          </>
        );
      }
    }

    const fileIcon = () => {
      if (existUploadFile) {
        return (
          <>
            <AttachFileIcon color='secondary' fontSize="large" onClick={() => downloadFile(props.openDialogRequest.actId, props.openDialogRequest.nodeId, existUploadFile.fileName)} />
          </>
        );
      } else {
        return (
          <>
            <Typography variant="body2" component="span" sx={{ margin: (theme) => theme.spacing(2) }}>ファイルが登録されていません</Typography>
          </>
        );
      }
    };

    const cancel = () => {
      if (existUploadFile) {
        return (
          <Tooltip title="添付資料を削除する">
            <IconButton sx={{
              color: (theme) => theme.palette.secondary.main,
              margin: 1,
            }} edge="end" aria-label="delete" onClick={() => handleDeleteUploadFile(existUploadFile)} >
              <CancelIcon />
            </IconButton >
          </Tooltip >
        );
      } else {
        return '';
      }
    };

    return (
      <>
        <span style={{ fontWeight: 'bold' }}>{label}</span>
        <span style={{ marginLeft: '10px' }}>
          {aliasTextField()}
          {fileIcon()}
          <input type='file' id={'file-input' + props.openDialogRequest.nodeId + type} style={{
            opacity: 0,
            appearance: 'none',
            position: 'absolute',
          }} onChange={selectedFile(props.openDialogRequest.nodeId, type)} />
          <label htmlFor={'file-input' + props.openDialogRequest.nodeId + type}>
            <Button color="secondary" variant='outlined' component='span'>ファイルを選択</Button>
          </label>
          {cancel()}
          {newFileObj}
          <br />
        </span>
      </>
    );
  }

  /**
     * アップロード済みファイルを取得。未アップロードの場合undefined
     * @param type 
     */
  const getFile = (type: string) => {
    const a = props.openDialogRequest.uploadFile.filter((value) => { return value.type === type });
    if (a.length > 0) {
      return a[0];
    } else {
      return undefined;
    }
  };

  const createList = () => {
    return (
      <>
        {createUploadFileItem('RevisionAct', getFile('RevisionAct'))}
        {createUploadFileItem('ContrastTable', getFile('ContrastTable'))}
        {createUploadFileItem('Etc1', getFile('Etc1'))}
        {createUploadFileItem('Etc2', getFile('Etc2'))}
        {createUploadFileItem('Etc3', getFile('Etc3'))}
      </>
    );
  };

  const [subDialog2, setSubDialog2] = React.useState(false);
  const openSubDialog2 = Boolean(subDialog2);
  const closeSubDialog2 = () => setSubDialog2(false);

  const [subDialog4, setSubDialog4] = React.useState(false);
  const openSubDialog4 = Boolean(subDialog4);
  const closeSubDialog4 = () => setSubDialog4(false);

  return (
    <Dialog fullScreen open={props.open} onClose={handleClose}>
      <header>
        <Box sx={{
          flexGrow: 1,
          height: (theme) => theme.spacing(8),
        }}>
          <AppBar position="fixed">
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" sx={{
                marginLeft: (theme) => theme.spacing(2),
                flex: 1,
              }}>
                添付資料
              </Typography>
              <Button autoFocus color="inherit" size="large" onClick={handleComplete}>
                完了
              </Button>
            </Toolbar>
          </AppBar>
        </Box>
      </header>
      <Paper sx={{
        width: '98%',
        margin: (theme) => theme.spacing(2),
        overflowX: 'auto',
      }}>
        <List>
          <NestedListItem key={'d'} level={1}>
            <ListItemText primary={createList()} />
          </NestedListItem>
        </List>
      </Paper>
      <Dialog
        open={openSubDialog2}
        keepMounted
        onClose={closeSubDialog2}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">警告</DialogTitle>
        <DialogContent>
          <Typography>登録可能なファイル形式は<br />［doc・docx・rtf・xls・xlsx・pdf・jpg・jpeg・png・gif・csv・jtd・zip］<br />です。</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeSubDialog2} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSubDialog4}
        keepMounted
        onClose={closeSubDialog4}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">警告</DialogTitle>
        <DialogContent>
          <Typography>アップロード可能なファイルサイズは5MBまでです。</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeSubDialog4} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};
